module.exports = __webpack_public_path__ + "img/4-2.eb9a85db.jpg";